export default __webpack_public_path__ + "static/local-7451d9369046fc37308b7c6f9247f9ac.png";